import React, { useEffect, useState, useRef } from "react";
import { Row, Col, Card, Label, Alert, Button} from "reactstrap";
import { useFetch } from "../../utils/fetchHook";
import { getCookie } from "../../jwt/_helpers/cookie";
import ModalConfirm from "../../components/modalConfirm";
import { Redirect } from "react-router-dom";
import TableHelper from "../../components/tableHelper"
import "react-day-picker/lib/style.css";

import Select from "react-select";
import Datetime from "react-datetime";

import { useTranslation } from "react-i18next";

import EarningsTable from "../../components/earningsTable";
import ViewLayout from "../../components/viewLayout";

const AddAccounting = () => {
  const token = getCookie("token");
  const [tableData, setTableData] = useState([]);

  const { t } = useTranslation();

  //ajax handlers
  const [success, setSuccess] = useState(false);
  const [errorPut, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState(t("accounting.add.message.errorSomethingWentWrong"));
  const [openModal, setToggleModal] = useState(false);
  const [dataModal, setDataModal] = useState(null);
  const [redirect, setRedirect] = useState(false);
  const [release_ops, setReleaseOps] = useState([]);

  const [startingMonth, setStartingMonth] = useState(Datetime.moment().subtract(15, 'month'));
  const [endingMonth, setEndingMonth] = useState(Datetime.moment().subtract(4, 'month'));

  let validRange = (selectedEndingMonth) => {
    let yearAfterStartingMonth = Datetime.moment(startingMonth).add(11, 'M');
    let isValidRange = selectedEndingMonth.isBetween(startingMonth, yearAfterStartingMonth);
    return isValidRange;
  };

  const [activeReleaseTab, setActiveReleaseTab] = useState({
    label: t("accounting.add.form.options.allReleases"),
    value: "0",
  });

  const didEff = useRef(false);

  const [forceUpdate, setForce] = useState(1);

  const [openEarnings, error, isloading] = useFetch("GET",
        "earnings/accounting-overview/?release=" + activeReleaseTab.value
        + "&period_start=" + startingMonth.format('MM-YYYY')
        + "&period_end=" + endingMonth.format('MM-YYYY'),
        token, false , forceUpdate);

  const handleFilterChange = (event, filter) =>
  {

    switch(filter) {
      case "release":
        setActiveReleaseTab(event);
        setError(false);
        setErrorMsg("");
        break;
      default:
        //do nothing
    }

  };

  const resetFilters = () =>
  {

    setActiveReleaseTab(
    {
      label: "All Releases",
      value: "0",
    });

    setStartingMonth(Datetime.moment().subtract(15, 'month'));
    setEndingMonth(Datetime.moment().subtract(4, 'month'));

    setError(false);
    setErrorMsg("");

  }

  const handleStartingMonthChange = (value) => {
    setStartingMonth(value);
    let yearAfterStartingMonth = Datetime.moment(value).add(11, 'M');
    setEndingMonth(yearAfterStartingMonth);
  }

  const handleEndingMonthChange = (value) => {
    setEndingMonth(value);
  }

  useEffect(() => {

    if (openEarnings.revenue_data)
    {
      setTableData(openEarnings.revenue_data);
    }

    if (openEarnings.releases)
    {
      let user_releases = [];

      var release_object = {};
      release_object["label"] = t("accounting.add.form.options.allReleases");
      release_object["value"] = "0";
      user_releases.push(release_object);

      openEarnings.releases.map(release => {

        var release_object = {};
        release_object["label"] = release.name;
        release_object["value"] = release.id;
        user_releases.push(release_object);

      });

      setReleaseOps(user_releases);
    }
  }, [openEarnings]);

  useEffect(() => {
    if (!didEff.current) {
      didEff.current = true;
      return;
    }
    setForce(prev => prev + 1);
  }, [activeReleaseTab, startingMonth, endingMonth]);


  const tableProps = {
    tableData,
  };

  function generateAccountingReport() {

    setError(false);
    setErrorMsg("");

    if(activeReleaseTab.value!=="0")
    {
      if(openEarnings.revenue_data.length>0)
      {
        setDataModal({
          release: activeReleaseTab.value,
          period_start: startingMonth,
          period_end: endingMonth
        });

        setToggleModal(true)
      }

      else
      {
        setError(true)
        setErrorMsg(t("accounting.add.message.errorNoEarningsAvailable"))
      }
    }
    else
    {
      setError(true)
      setErrorMsg(t("accounting.add.message.errorNoReleaseSelected"))
      
    }
  }

  return (
    <>
        <Card className="">
        <h5 className="ml-4 mt-4">{t("accounting.add.form.label.filters")}</h5>
        <Row className="mb-4">
            <Col className="col-lg-6 col-md-6 col-sm-12 col-12">
            <div className="mx-4">
                <Label>{t("accounting.add.form.label.monthRange")}</Label>
                <div className="starting-month">
                    <Datetime locale="en-gb"
                    dateFormat="YYYY-MM"
                    timeFormat={false}
                    inputProps={{ placeholder: t("accounting.add.form.placeholder.startingMonth") }}
                    value={startingMonth}
                    onChange={handleStartingMonthChange}
                    />
                </div>
                <div className="ending-month">
                    <Datetime locale="en-gb"
                    dateFormat="YYYY-MM"
                    timeFormat={false}
                    inputProps={{ placeholder: t("accounting.add.form.placeholder.endingMonth") }}
                    value={endingMonth}
                    isValidDate={validRange}
                    onChange={handleEndingMonthChange}
                    />
                </div>
            </div>
            </Col>

            <Col className="col-lg-6 col-md-6 col-sm-12 col-12">
            <div className="mx-4">
                <Label>{t("accounting.add.form.label.release")}</Label>
                <Select
                    components={{ IndicatorSeparator: () => null }}
                    name="release_filter"
                    options={release_ops}
                    value={activeReleaseTab}
                    onChange={(e) => handleFilterChange(e, "release")}
                />
            </div>
            </Col>
        </Row>

        <Row>
        <Col className="col-lg-12 col-md-12 col-sm-12 col-12">
            <div className="mx-4 mb-4" style={{ float: "right"}}>
                <Button
                    className="btn btn-outline-success"
                    style={{maxWidth: "250px", height: "40px", marginRight: "10px"}}
                    onClick={() => generateAccountingReport()}
                >
                    {t("accounting.add.form.button.generate")}
                </Button>
                <Button
                className="btn btn-outline-info"
                style={{width: "160px", height: "40px"}}
                onClick={() => { resetFilters() }}>
                {t("accounting.add.form.button.reset")}
                </Button>
            </div>
            </Col>
        </Row>
        </Card>
      {isloading ? (
        <TableHelper loading />
      ) : error ? (
        <TableHelper error />
      ) : (
        <div className="mb-5">

          <div>
              {success && (
                <Alert color="success">{t("accounting.add.message.success")}</Alert>
              )}
              {redirect ? <Redirect to="/accounting" /> : null}
              {errorPut && (
                <Alert color="danger">
                  {errorMsg}
                </Alert>
              )}
          </div>

          <ViewLayout title={t("accounting.add.form.table.title")}>
            <EarningsTable {...tableProps}/>
          </ViewLayout>

        </div>
      )}

      {
        <ModalConfirm
          openModal={openModal}
          setToggleModal={setToggleModal}
          dataModal={dataModal}
          title={t("accounting.add.modal.header")}
          setSuccess={setSuccess}
          setError={setError}
          body={t("accounting.add.modal.body", {
            release: activeReleaseTab.label,
            startingMonth: startingMonth.format('MMM-YYYY'),
            endingMonth: endingMonth.format('MMM-YYYY')
          })}
          apiURL={`accounting_reports/generate-accounting-report`}
          setRedirect={setRedirect}
        />
      }
    </>
  );
};

export default AddAccounting;
